import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { StatesList } from './StatesList';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
export function HowToStart() {
  return <section className="mb-16" data-id="element-47">
      <FadeIn data-id="element-48">
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 shadow-sm" data-id="element-49">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-[#111] mb-8" data-id="element-50">
            Find Your State to See Local Window Prices
          </h3>
          <StatesList data-id="element-51" />
        </div>
      </FadeIn>

      {/* Final CTA */}
      <FadeIn data-id="element-52">
        <div className="flex flex-col items-center mt-12" data-id="element-53">
          <CTAButton className="mb-6" data-id="element-54">Get My Free Price Estimate</CTAButton>

          <div className="flex flex-col items-center gap-2 text-sm text-gray-500" data-id="element-55">
            <div className="flex items-center gap-1.5" data-id="element-56">
              <LockIcon className="w-4 h-4" data-id="element-57" />
              <span data-id="element-58">Your information is secure. No spam, ever.</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-59">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-60" />
              <span data-id="element-61">Free service — no credit card required</span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}